<template>
  <div v-if="show">
    <div class="row">
      <div class="col-lg-6 pr-0">
        <b-form-group
          id="fieldset-createTime"
          label-for="createTime"
          label-size="lg"
          label-class="font-weight-bold pb-0"
        >
          <template slot="label">
            <span v-text="$t('commons.createTime')" />
          </template>
          <b-form-input
            id="createTime"
            name="createTime"
            :value="form.createTime | datetime"
            disabled
          />
        </b-form-group>
      </div>
      <div class="col-lg-6 pl-2">
        <b-form-group
          id="fieldset-lastModifiedTime"
          label-for="lastModifiedTime"
          label-size="lg"
          label-class="font-weight-bold pb-0"
        >
          <template slot="label">
            <span v-text="$t('commons.lastModifiedTime')" />
          </template>
          <b-form-input
            id="lastModifiedTime"
            name="lastModifiedTime"
            :value="form.lastModifiedTime | datetime"
            disabled
          />
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import { useManageAttributes } from "../../stores/manage-attributes";
export default {
  props: {
    show: Boolean,
  },
  computed: {
    form() {
      return this.useManageAttributes.getForm;
    },
  },
  data() {
    return {
      useManageAttributes: useManageAttributes(),
    };
  },
};
</script>
